import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/usr-address/{uuid}';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type GetMyAccountAddressesDetailInput = paths[url]['get']['parameters']['path'];

export interface GetMyAccountAddressesDetailSuccessResponse {
    data: paths[url]['get']['responses']['200']['content']['application/json'];
}

/**
 * Requests endpoint to get an address.
 */
export const useGetMyAccountAddressesDetail = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setAddressesDetail, setIsLoadingAddressesDetail } = useData();

    const request = async (props: GetMyAccountAddressesDetailInput) => {
        setIsLoadingAddressesDetail(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL.replace('{uuid}', props.uuid || '')}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const json = await response.json();
                const error = new Error(json.error || '') as ApiError;
                error.statusCode = response.status;
                throw error;
            }

            const data: GetMyAccountAddressesDetailSuccessResponse = await response.json();

            setAddressesDetail(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err: any) {
            handleCommonErrors(err);
        } finally {
            setIsLoadingAddressesDetail(false);
        }
    };

    return { request };
};
